<template>
  <div class="main">
    <div class="main__navigation">
      <navigation />
    </div>
    <div class="main__content">
      <transition
        name="fade"
        enter-active-class="fadeInRight"
        leave-active-class="fadeOut"
        mode="out-in"
      >
        <keep-alive>
          <router-view style="animation-duration: 0.35s" />
        </keep-alive>
      </transition>
    </div>
    <user-menu />
    <media-carousel />
    <user-multimedia-modal />
    <message-broker />
    <chat-button />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import gql from 'graphql-tag';
import UserMenu from '@/components/UserMenu.vue';
import UserMultimediaModal from '@/components/UserMultimedia.vue';
import listConfigurationGql from '@/graphql/queries/listConfiguration.gql';
import configurationGql from '@/graphql/suscriptions/configuration.gql';
import agentActionsGql from '@/graphql/suscriptions/agentActions.gql';
import { onLogout } from '@/vue-apollo';
import apolloProvider from '@/apollo';
import ChatButton from '@/components/chatButton/index.vue';

export default {
  components: {
    MessageBroker: () => import('@/components/common/MessageBroker.vue'),
    MediaCarousel: () => import('@/components/MediaCarousel.vue'),
    Navigation: () => import('@/components/Navigation.vue'),
    UserMenu,
    ChatButton,
    UserMultimediaModal,
  },
  data: () => ({
    listConfiguration: [],
  }),
  computed: {
    ...mapState({
      ready: (state) => state.ready,
      userData: (state) => state.user,
    }),
    skipConfig() {
      return this.ready;
    },
  },
  apollo: {
    listConfiguration() {
      return {
        query: gql`${listConfigurationGql}`,
        skip() {
          return !this.skipConfig;
        },
        subscribeToMore: [
          {
            document: gql`${configurationGql}`,
            updateQuery: (previousResult, { subscriptionData }) => {
              const { configuration: config } = subscriptionData.data;

              if (config.key && config.key === 'configuration') {
                this.setCampaingConfig(config);
              } else if (config.key) {
                this.setCampaingDataBank(config);
              } else {
                this.setConfiguration(config);
                this.setUser({ ...this.userData, status: config.agentStatus });
              }
            },
          },
          {
            document: gql`${agentActionsGql}`,
            updateQuery: (previousResult, { subscriptionData }) => {
              const { agentActions: { status } } = subscriptionData.data;
              if (status === 'offline') {
                onLogout(apolloProvider.defaultClient);
              } else {
                this.setUser({ ...this.userData, status });
              }
            },
          },
        ],
      };
    },
  },
  methods: {
    ...mapMutations([
      'resetActiveClients',
      'setConfiguration',
      'setUser',
      'setCampaingDataBank',
      'setCampaingConfig',
    ]),
  },
  watch: {
    '$route.path': function routeWatcher() {
      this.resetActiveClients();
    },
  },
};
</script>

<style lang="scss">
.header {
  background-color: var(--header);
  text-align: center;

  &__logo {
    width: 100px;
    height: 45px;
    padding: 5px 0px;
  }
}
</style>
